import {Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {SelectableItem} from './selectable-item';

@Component({
  selector: 'app-horizontal-item-selection',
  templateUrl: './horizontal-item-selection.component.html',
  styleUrls: ['./horizontal-item-selection.component.scss']
})
export class HorizontalItemSelectionComponent implements OnInit, OnDestroy {
  @Input() items: Array<SelectableItem>;
  @Output() itemSelected: EventEmitter<SelectableItem>;
  @HostBinding('class.horizontal-item-selection') horizontalItemSelection = true;

  public currentSelection: BehaviorSubject<SelectableItem> = new BehaviorSubject<SelectableItem>(null);
  public currentSelectionSubscription: Subscription;
  constructor() {
    this.itemSelected = new EventEmitter<SelectableItem>();
  }

  ngOnInit() {
    this.currentSelection.next(this.items[0]);
    this.currentSelectionSubscription = this.currentSelection.subscribe(
      item => this.itemSelected.emit(item)
    );
  }
  ngOnDestroy() {
    this.currentSelectionSubscription.unsubscribe();
  }

  itemClick(item: SelectableItem) {
    this.currentSelection.next(item);
  }
  itemIsSelected(anItem: SelectableItem, selectedItem: SelectableItem) {
    return anItem.name === selectedItem.name;
  }
}
